export const Loading = () => {
  return (
    <div>
      <div className='wrapper1'>
        <div className='circle'></div>
        <div className='circle'></div>
        <div className='circle'></div>
        <div className='shadow'></div>
        <div className='shadow'></div>
        <div className='shadow'></div>
        <span>Loading</span>
      </div>
    </div>
  );
};
